import React, { useState } from "react";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "../styles/register.css";
import { logUserAction } from "../utils/logUtils";

const Register: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    const { firstName, lastName, email, password } = formData;

    try {
      const userCred = await createUserWithEmailAndPassword(auth, email, password);

      // Ajoute dans Firestore
      await setDoc(doc(db, "Users", email.toLowerCase()), {
        firstName,
        lastName,
        role: "foodinnov",
        authUid: userCred.user.uid,
      });

      // Enregistrer l'action utilisateur
      await logUserAction(
        email.toLowerCase(),
        "Inscription",
        `Nouvel utilisateur: ${email.toLowerCase()}`
      );

      navigate("/");
    } catch (err: any) {
      console.error("Erreur inscription :", err);
      setError(err.message);
    }
  };

  return (
    <div className="register-container">
      <h2>Créer un compte utilisateur</h2>
      <form onSubmit={handleRegister}>
        <input type="text" name="firstName" placeholder="Prénom" required onChange={handleChange} />
        <input type="text" name="lastName" placeholder="Nom" required onChange={handleChange} />
        <input type="email" name="email" placeholder="Email" required onChange={handleChange} />
        <input type="password" name="password" placeholder="Mot de passe" required onChange={handleChange} />
        <button type="submit">S'inscrire</button>
        {error && <p className="error-message">{error}</p>}
      </form>
    </div>
  );
};

export default Register;
